import { SalariesReportFeedback } from 'modules/salaries/types/SalariesReportFeedback';
import { postJson } from 'utils/http/postJson';

export function salariesSubmitReportFeedback({
  rating,
  selectedSynonymId,
  city,
  stateCode,
  latitude,
  longitude,
  yearsOfExperience,
}: SalariesReportFeedback) {
  return postJson('/data/salary-surveys/rate-calculator', {
    rating,
    selectedSynonymId,
    city,
    stateCode,
    latitude,
    longitude,
    yearsOfExperience,
  });
}
